import { routes } from '@/api/endpoints/collection'

export const guardedRoutes = [
  {
    path: '/documentation',
    name: 'Documentation',
    component: () => import('@/views/guarded/documentation/Index.vue'),
    meta: { requiresAuth: true },
    children: routes.value
  },
  {
    path: '/console',
    name: 'Console',
    component: () => import('@/views/guarded/console/Index.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: 'store-list',
        name: 'Store List',
        component: () => import('@/views/guarded/console/app-list/StoreList.vue')
      },
      {
        path: 'app-list',
        name: 'App List',
        component: () => import('@/views/guarded/console/app-list/Index.vue')
      },
      {
        path: 'login-app',
        name: 'Login App',
        component: () => import('@/views/guarded/console/app-list/LoginApp.vue')
      }
    ]
  },
  {
    path: '/app-detail',
    name: 'App Detail',
    component: () => import('@/views/guarded/console/app-list/AppDetail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/app-edit',
    name: 'App Edit',
    component: () => import('@/views/guarded/console/app-list/AppEdit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/create-app',
    name: 'Create App',
    component: () => import('@/views/guarded/console/app-list/AppCreate.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/api-test-tool',
    name: 'Api Test Tool',
    component: () => import('@/views/guarded/documentation/collection/ApiTool.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/api-webhook-tool',
    name: 'Api Webhook Tool',
    component: () => import('@/views/guarded/documentation/collection/WebhookTool.vue'),
    meta: { requiresAuth: true }
  }
]

export default guardedRoutes
